import {Provider} from '@angular/core';
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from '../../../core/shared/test/data/test-harness.types';
import {JobDashboardPage} from '../page/job-dashboard-page/job-dashboard.page';
import {
    JbJobBatchStatsComponent
} from '../component/protected-components/jb-job-batch-stats/jb-job-batch-stats.component';
import {
    JbJobExecutionOverlapComponent
} from '../component/protected-components/jb-job-execution-overlap-component/jb-job-execution-overlap.component';
import {
    JbJobGroupBatchOverviewComponent
} from '../component/protected-components/jb-job-group-batch-overview-component/jb-job-group-batch-overview.component';
import {
    JbJobInstanceDetailsComponent
} from '../component/protected-components/jb-job-instance-details-component/jb-job-instance-details.component';
import {JbJobStatusComponent} from '../component/protected-components/jb-job-status/jb-job-status.component';
import {
    JbSingleJobBatchOverviewComponent
} from '../component/protected-components/jb-single-job-batch-overview-component/jb-single-job-batch-overview.component';
import {
    JbJobRunObjectComponent
} from '../component/protected-components/object-base/jb-job-run-object-component/jb-job-run-object.component';
import {
    JbJobRunSideComponent
} from '../component/protected-components/object-base/jb-job-run-object-component/view/side/jb-job-run-side.component';
import {
    JbJobRunFullComponent
} from '../component/protected-components/object-base/jb-job-run-object-component/view/full/jb-job-run-full.component';
import {JbConfigPagePage} from '../page/jb-config-page/jb-config-page.page';
import {
    JbDashboardOverviewComponent
} from '../component/protected-components/jb-dashboard-overview-component/jb-dashboard-overview.component';
const jbModuleEntry: TestModuleDefinition = {
    key: 'jb',
    label: 'Job Run (jb)',
    components: [
        {
            key: 'JbJobBatchStatsComponent',
            component: JbJobBatchStatsComponent,
            selector: 'mvs-jb-job-batch-stats',
            type: 'Component',
            label: 'jb job batch stats component'
        },
        {
            key: 'JbJobExecutionOverlapComponent',
            component: JbJobExecutionOverlapComponent,
            selector: 'jb-job-execution-overlap-component',
            type: 'Component',
            label: 'jb job execution overlap component'
        },
        {
            key: 'JbJobGroupBatchOverviewComponent',
            component: JbJobGroupBatchOverviewComponent,
            selector: 'jb-job-group-batch-overview-component',
            type: 'Component',
            label: 'jb job group batch overview component'
        },
        {
            key: 'JbJobInstanceDetailsComponent',
            component: JbJobInstanceDetailsComponent,
            selector: 'jb-job-instance-details',
            type: 'Component',
            label: 'jb job instance details component'
        },
        {
            key: 'JbJobStatusComponent',
            component: JbJobStatusComponent,
            selector: 'jb-job-status',
            type: 'Component',
            label: 'jb job status component'
        },
        {
            key: 'JbSingleJobBatchOverviewComponent',
            component: JbSingleJobBatchOverviewComponent,
            selector: 'jb-single-job-batch-overview-component',
            type: 'Component',
            label: 'jb single job batch overview component'
        },
        {
            key: 'JbJobRunObjectComponent',
            component: JbJobRunObjectComponent,
            selector: 'jb-job-run-object-component',
            type: 'ObjectBaseComponent',
            label: 'jb job run object component'
        },
        {
            key: 'JbJobRunSideComponent',
            component: JbJobRunSideComponent,
            selector: 'jb-job-run-side',
            type: 'JbJobRunBaseComponent',
            label: 'jb job run side component'
        },
        {
            key: 'JbJobRunFullComponent',
            component: JbJobRunFullComponent,
            selector: 'jb-job-run-full',
            type: 'JbJobRunBaseComponent',
            label: 'jb job run full component'
        },
        {
            key: 'JbConfigPagePage',
            component: JbConfigPagePage,
            selector: 'lg-config-page',
            type: 'PageComponent',
            label: 'jb config page page'
        },
        {
            key: 'JobDashboardPage',
            component: JobDashboardPage,
            selector: 'jb-job-dashboard',
            type: 'PageComponent',
            label: 'job dashboard page'
        },
        {
            key: 'JbDashboardOverviewComponent',
            component: JbDashboardOverviewComponent,
            selector: 'jb-dashboard-overview',
            type: 'Component',
            label: 'jb dashboard overview component'
        }
    ]
}

export const JB_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: jbModuleEntry, multi: true}
];
